export default function canUseNewRpa({ forceUseNewRpa = null, rootState, targetUser = {} }) {
  if (forceUseNewRpa !== null) return forceUseNewRpa;

  const user = rootState.user.user;
  if (!user || !user.role) return false;

  const isMonitor = user.role === "monitor";
  const isSuperAdmin = user.role === "superadmin";

  const validPlatforms = ["free", "group"];

  const userPT = Array.isArray(user.platformType) ? user.platformType : [user.platformType].filter(Boolean);

  const matchesValidPlatform = (pt) => {
    const arr = Array.isArray(pt) ? pt : [pt].filter(Boolean);
    return arr.some((v) => validPlatforms.includes(v));
  };

  if (!isSuperAdmin && isMonitor) {
    return matchesValidPlatform(userPT);
  }
  const findRoom = rootState.rooms.data.find((r) => r.ip === targetUser.ips?.[0]);

  if (targetUser.room !== "Satelite") {
    return matchesValidPlatform(findRoom?.platformType);
  }

  return matchesValidPlatform(targetUser.platformType);
}
